(function () {
  'use strict';

  // Mobile navigation
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var nav = document.getElementById('SiteNav');
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    var searchToggle = e.target.closest('[data-search-toggle]');
    if (searchToggle) {
      var bar = document.getElementById('SearchBar');
      var isOpen = bar.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        var input = bar.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    }

    // Product gallery thumbnails
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      var main = document.querySelector('[data-gallery-main]');
      if (main) {
        main.src = thumb.getAttribute('data-thumb');
        main.srcset = '';
        document.querySelectorAll('[data-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', b === thumb ? 'true' : 'false');
        });
      }
    }
  });

  // Variant picker: keep the hidden variant id and price in sync
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-variant-select]');
    if (!select) return;
    var option = select.options[select.selectedIndex];
    var form = select.closest('form');
    var idInput = form.querySelector('[name="id"]');
    if (idInput) idInput.value = option.value;
    var priceEl = document.querySelector('[data-product-price]');
    if (priceEl && option.dataset.price) priceEl.firstChild.textContent = option.dataset.price;
    var button = form.querySelector('[data-add-button]');
    if (button) {
      var available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
    }
  });

  // Sort-by on collection pages
  document.addEventListener('change', function (e) {
    var sort = e.target.closest('[data-sort-by]');
    if (!sort) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
})();
